var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyCollectionVideoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12062",
    "data-name": "Group 12062",
    transform: "translate(-787 -626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumbnail_no_preview",
    transform: "translate(787 626)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7470",
    "data-name": "Rectangle 7470",
    width: 180,
    height: 180,
    fill: "#202020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11585",
    "data-name": "Group 11585",
    transform: "translate(772.98 637.66)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5885",
    "data-name": "Path 5885",
    d: "M93.46,116.02h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5886",
    "data-name": "Path 5886",
    d: "M94.01,116.08h.05a2.817,2.817,0,0,0,1.38-.37,3.631,3.631,0,0,1-1.5.36h.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M-7363.78,7821.284v-6.226a2.072,2.072,0,0,1,.07-.5l-10.841-6.073h-.04v-.022l-8.67-4.857a3.439,3.439,0,0,1-1.779-2.986v-25.51a3.44,3.44,0,0,1,1.779-2.988l20.141-11.28v-3.008l-1.779.989-13.122,7.324-4.82,2.7a2.122,2.122,0,0,1-2.859-.748,1.992,1.992,0,0,1,.619-2.678l5.12-2.871,14.69-8.205,3.239-1.814a2.287,2.287,0,0,1,.562-.155h.049a1.532,1.532,0,0,1,.22-.02c.051,0,.14-.01.14-.01a2.062,2.062,0,0,1,2.091,2.038v4.549a3.631,3.631,0,0,1,1.61.251v-4.8a2.066,2.066,0,0,1,2.089-2.028,2.06,2.06,0,0,1,2.091,2.028v6.556a2.135,2.135,0,0,1-.081.515l13.97,7.828v4.695l-5.429-3.042V7799c0,2.26-1.251,3.628-3.042,3.628a3.335,3.335,0,0,1-2.5-1.17l-18.56-18.1v23.055l9.159,5.13a2.974,2.974,0,0,0,1.48.389,3.075,3.075,0,0,0,1.48-.389l15.964-8.552-.008,0v-20.928h19.833v4.675h-14.474l.031,17.6.016,0-.016.008v.006l-.006,0-18.02,10.027v3.424l1.779-.989,13.122-7.324,4.82-2.7a2.122,2.122,0,0,1,2.861.746,2,2,0,0,1-.621,2.678l-5.121,2.871-14.69,8.205-3.24,1.814a2.3,2.3,0,0,1-.56.155h-.051a1.538,1.538,0,0,1-.22.02c-.049,0-.14.01-.14.01a2.06,2.06,0,0,1-2.091-2.036v-4.627a3.462,3.462,0,0,1-1.17.2,3.6,3.6,0,0,1-.9-.116v4.566a2.065,2.065,0,0,1-2.091,2.028A2.058,2.058,0,0,1-7363.78,7821.284Zm4.119-57.072-18.91,10.593a2.848,2.848,0,0,0-1.48,2.481v21.185a2.866,2.866,0,0,0,1.48,2.484l3.98,2.229v-26.053c0-2.221,1.17-3.591,3.041-3.591a3.328,3.328,0,0,1,2.46,1.131l18.56,17.82v-24.816l-6.181-3.462a3,3,0,0,0-1.475-.386A3,3,0,0,0-7359.661,7764.212Zm49.181,39.818v-17.113h-7.675v-4.675h20.675v4.675h-8v17.113Zm-22.475-8.661v-3.958h10.516v3.958Z",
    transform: "translate(7446 -7712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5888",
    "data-name": "Path 5888",
    d: "M86.35,52.59,67.44,63.51a2.965,2.965,0,0,0-1.48,2.56V87.91a2.956,2.956,0,0,0,1.48,2.56l18.91,10.92a3.016,3.016,0,0,0,1.48.4,2.914,2.914,0,0,0,1.48-.4l17.42-10.06V62.65L89.31,52.59a2.935,2.935,0,0,0-2.95,0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCollectionVideoPlaceholder);
export default __webpack_public_path__ + "static/media/myCollectionVideoPlaceholder.0aa5951fb553255b1de169296481d0c3.svg";
export { ForwardRef as ReactComponent };